import startCase from 'lodash/startCase';

import { isBeaglyAdmin, selectCurrentUserId } from '../user/selectors.user';
import { getFullName, makeColumnSort } from '../../util';

export const isOrganizationAdmin = (state, organizationId, userId) => {
  if (!organizationId) return false;
  if (isBeaglyAdmin(state)) return true;
  const currentUserId = userId || selectCurrentUserId(state);
  return !!state.memberships.findKey(
    (membership) =>
      membership.get('organizationId') === organizationId &&
      membership.get('userId') === currentUserId &&
      membership.get('role') === 'admin',
  );
};

const getDisplayRole = (role) => {
  if (!role) return 'None';
  return role === 'admin' ? 'Organization Admin' : startCase(role);
};

const makeMembershipEnhancer = (state, organizationId) => (membership) => {
  const currentUserId = selectCurrentUserId(state);
  const firstName = membership.get('firstName');
  const lastName = membership.get('lastName');
  const userId = membership.get('userId');
  const fullName = getFullName({ firstName, lastName });
  const role = membership.get('organizationId') === organizationId ? membership.get('role') : null;
  const isEditable =
    userId === currentUserId ? false : isOrganizationAdmin(state, organizationId, currentUserId);
  const displayRole = membership.get('isSystemAdmin') ? 'System Admin' : getDisplayRole(role);
  return membership.merge({ displayRole, fullName, isEditable });
};

export const selectMemberships = (state, organizationId) =>
  state.memberships.toList().map(makeMembershipEnhancer(state, organizationId)).toJS();

export const selectCurrentMembershipsHaveSysadmin = (state) =>
  state.memberships.toList().some((membership) => membership.get('isSystemAdmin'));

const makeMembershipsFilter = (organizationId, criteria) => (membership) => {
  if (organizationId && membership.get('organizationId') !== organizationId) return false;
  if (!criteria) return true;
  return membership.valueSeq().join(' ').toLowerCase().includes(criteria.toLowerCase());
};
export const selectOrganizationMemberships = ({ state, isGlobal, organizationId, query }) => {
  const rawMemberships = state.memberships.filter(
    makeMembershipsFilter(isGlobal ? null : organizationId, query.criteria),
  );
  return rawMemberships
    .groupBy((item) => item.get('userId'))
    .map((item) => item.first())
    .map(makeMembershipEnhancer(state, organizationId))
    .toList()
    .sort(makeColumnSort(query, { sortBy: 'fullName', sortDirection: 'asc' }));
};

export const selectUserMemberships = (state, userId) =>
  state.memberships
    .filter((membership) => membership.get('userId') === userId)
    .map(makeMembershipEnhancer(state))
    .toList()
    .toJS();

export const selectMembership = (state, userId, organizationId) =>
  selectMemberships(state, organizationId).find(
    (currentMembership) =>
      currentMembership.userId === userId && currentMembership.organizationId === organizationId,
  );
